import memoize from "lodash/memoize";

import { DEFAULT_PRODUCTS_PER_PAGE } from "utils/products";

export const getProductsLimit = memoize(
  (ref: React.RefObject<HTMLElement>, rows: number = 5): number => {
    if (!ref.current) {
      return DEFAULT_PRODUCTS_PER_PAGE;
    }

    const { gridTemplateColumns } = getComputedStyle(ref.current);
    const columns = gridTemplateColumns.split(" ").length;
    return columns > 0 ? columns * rows : DEFAULT_PRODUCTS_PER_PAGE;
  },
  (ref, rows) => {
    if (!ref.current) {
      return "default";
    }

    return `${ref.current.className}|${rows}`;
  }
);
